export default "__VITE_ASSET__119a409b__"